import optimizelySdk, { enums } from '@optimizely/optimizely-sdk';
import { ComponentEventBus } from './event-bus';
import { Env } from "@stencil/core";

const client = optimizelySdk.createInstance({
  sdkKey: Env.OPTIMIZELY_SDK_KEY,
  logLevel: enums.LOG_LEVEL.ERROR,
});

const featureFlags = [
  { eventName: 'enableAppDirectory', featureFlag: 'enable_app_directory' },
];

export const setupFeatureFlags = (email: string) => {
  featureFlags.forEach(({ eventName }) => {
    ComponentEventBus.register(eventName, { type: 'boolean' });
  });

  client.onReady().then(() => {
    featureFlags.forEach(({ eventName, featureFlag }) => {
      const isEnabled = client.isFeatureEnabled(featureFlag, '', { email });
      ComponentEventBus.publish(eventName, isEnabled);
    });
  });
};
